// // src/Loan/LoanCard.jsx
// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { data, useLocation, useParams } from "react-router-dom";
// import { fetchLoanEmis, clearLoanEmis } from "../redux/slices/loan/loanEmiSlice";
// import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
// import jsPDF from "jspdf";
// import Barcode from "react-barcode";
// import html2canvas from "html2canvas";
// import "../assets/Loan/LoanCard.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// // Utils
// const formatDate = (dateStr) => {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
// };
// const formatAmount = (amount) =>
//   !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

// const LoanCard = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const cardRef = useRef();
//   const location = useLocation();
//   const currentuserid= location.state?.loan;
//   // console.log("currenet user id",currentuserid);

//   const { emis, loading: emiLoading, error: emiError } = useSelector(
//     (state) => state.loanEmi
//   );

//   // console.log(emis);
//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { profile } = useSelector((state) => state.userProfile);

//   const [company, setCompany] = useState(null);
//   const [photoUrl, setPhotoUrl] = useState(null);
//   const [customerDetails,setCustomerDetails]=useState(null);

//   const createdById = Number(localStorage.getItem("userId")) || 0;

//   // ✅ Fetch Profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ✅ Fetch Loan + Company
//   useEffect(() => {

//     if (loanId) {
//       dispatch(fetchLoanEmis(loanId));
//       if (loans.length === 0) dispatch(fetchAllLoans());
//     }

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           }
//           if(data.qrCodeImage){
//             data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Error fetching company:", err);
//       }
//     };
//     if (profile?.superAdminId) fetchCompany();

//     return () => dispatch(clearLoanEmis());
//   }, [dispatch, loanId, loans.length, profile?.superAdminId]);

//   const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
//   const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";
//   // const branchId=emis?.[0]?.branchId || 0;

//   // ✅ Fetch Customer Photo (filtered by 'photo' docName)
//   useEffect(() => {

//           const branchId = Number(localStorage.getItem("userId")) || 0;

//     const fetchCustomerDetails = async () => {
//        try {
//             const res = await fetch(
//               `https://payyug.in/api/customers-get-userId?userId=${loan.customerId}&branchId=${branchId}`
//             );

//             const data = await res.json();
//              console.log("Customer API Response:", data);
//             setCustomerDetails(data.data);
//           } catch (err) {
//             console.error("Customer fetch error:", err);
//           }
//     };
//     const fetchCustomerPhoto = async () => {
//       try {
//         if (loan?.customerId && profile?.superAdminId) {
//           const res = await fetch(
//             `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`
//           );
//           const data = await res.json();
//           if (res.ok && data.documents?.length > 0) {
//             const photoDoc = data.documents.find(
//               (doc) => doc.docName?.toLowerCase() === "photo"
//             );
//             if (photoDoc?.docImage) {
//               setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
//             }
//           }
//         }
//       } catch (err) {
//         console.error("Failed to fetch customer photo:", err);
//       }
//     };
//     fetchCustomerDetails();
//     fetchCustomerPhoto();
//   }, [loan?.customerId, profile?.superAdminId, createdById]);

// // const generatePDF = async () => {
// //   const input = cardRef.current;
// //   if (!input) return;

// //   const pdf = new jsPDF("p", "mm", "a4");
// //   const pageWidth = pdf.internal.pageSize.getWidth();
// //   const pageHeight = pdf.internal.pageSize.getHeight();

// //   const canvas = await html2canvas(input, {
// //     scale: 2,
// //     useCORS: true,
// //     allowTaint: true,
// //     scrollY: -window.scrollY,
// //   });

// //   const imgWidth = pageWidth - 20;      // 10mm left + 10mm right margin
// //   const pageImageHeight = pageHeight - 20; // 10mm top + 10mm bottom margin

// //   const totalImageHeight = (canvas.height * imgWidth) / canvas.width;

// //   let renderedHeight = 0;

// //   while (renderedHeight < totalImageHeight) {

// //     // CREATE TEMPORARY CANVAS FOR EACH PAGE
// //     const pageCanvas = document.createElement("canvas");
// //     pageCanvas.width = canvas.width;
// //     pageCanvas.height =
// //       (pageImageHeight * canvas.width) / imgWidth;

// //     const ctx = pageCanvas.getContext("2d");

// //     // COPY PART OF FULL IMAGE → PAGE IMAGE
// //     ctx.drawImage(
// //       canvas,
// //       0,
// //       (renderedHeight * canvas.width) / imgWidth,
// //       canvas.width,
// //       pageCanvas.height,
// //       0,
// //       0,
// //       canvas.width,
// //       pageCanvas.height
// //     );

// //     const pageImgData = pageCanvas.toDataURL("image/png");
// //     const pageImgHeight = (pageCanvas.height * imgWidth) / canvas.width;

// //     if (renderedHeight === 0) {
// //       // FIRST PAGE
// //       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
// //     } else {
// //       // OTHER PAGES
// //       pdf.addPage();
// //       pdf.addImage(pageImgData, "PNG", 10, 10, imgWidth, pageImgHeight);
// //     }

// //     renderedHeight += pageImageHeight;
// //   }

// //   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// // };

// const generatePDF = async () => {
//   const input = cardRef.current;
//   if (!input) return;

//   const pdf = new jsPDF("p", "mm", "a4");
//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   // Set margins (10mm is standard)
//   const margin = 10;
//   const contentWidth = pageWidth - (margin * 2);
//   const contentHeight = pageHeight - (margin * 2);

//   const canvas = await html2canvas(input, {
//     scale: 2, // Keeps text sharp
//     useCORS: true,
//     backgroundColor: "#ffffff",
//     scrollY: -window.scrollY,
//   });

//   const imgWidth = canvas.width;
//   // Calculate how many pixels of the canvas fit into one PDF page
//   const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;

//   let heightLeft = canvas.height;
//   let sY = 0; // Source Y position on the canvas

//   while (heightLeft > 0) {
//     // Determine the height of the slice for this page
//     const sHeight = Math.min(heightLeft, pixelPageHeight);

//     const pageCanvas = document.createElement("canvas");
//     pageCanvas.width = imgWidth;
//     pageCanvas.height = sHeight;

//     const ctx = pageCanvas.getContext("2d");
//     ctx.drawImage(
//       canvas,
//       0, sY,         // Source X, Y
//       imgWidth, sHeight, // Source Width, Height
//       0, 0,          // Destination X, Y
//       imgWidth, sHeight  // Destination Width, Height
//     );

//     const pageImgData = pageCanvas.toDataURL("image/jpeg", 1.0);

//     // Calculate the display height in mm for the PDF
//     const displayHeight_mm = (sHeight * contentWidth) / imgWidth;

//     if (sY > 0) pdf.addPage();

//     pdf.addImage(
//       pageImgData,
//       "JPEG",
//       margin,
//       margin,
//       contentWidth,
//       displayHeight_mm
//     );

//     // Update trackers
//     sY += sHeight;
//     heightLeft -= sHeight;
//   }

//   pdf.save(`LoanCard_${loan?.loanAccountNumber || loan?.loanNumber}.pdf`);
// };

// console.log("emis",emis)

//   if (loanLoading || emiLoading)
//     return <div className="branch-loan-card-container">Loading...</div>;
//   if (loanError || emiError)
//     return (
//       <div className="branch-loan-card-container">{loanError || emiError}</div>
//     );
//   if (!loan)
//     return (
//       <div className="branch-loan-card-container">
//         No loan found for Loan ID {loanId}
//       </div>
//     );

//   return (
//     <div>
//       <div className="branch-loan-card-container" ref={cardRef}>
//         {/* Header */}
//         <header className="branch-loan-card-header">
//           <div className="branch-loan-card-logo-box">
//             {company?.logoUrl && (
//               <img
//                 src={company.logoUrl}
//                 alt="Logo"
//                 className="branch-loan-card-logo"
//               />
//             )}
//           </div>

//           <div className="branch-loan-card-details-box">
//             <h2>{company?.name || "Company Name"}</h2>
//             <p>
//               <strong>CIN:</strong> {company?.cin || "-"}
//               <br />
//              {/* <strong>Regt. Office:</strong>*/} {company?.address || "-"}
//               {/* <b>Regt. Office:</b> {company?.ddress || "weriyfbup qcpqrhopwinhqguoq cwheruip chpefuib cuw hfwoeicf wperuoi hwe[cfio weuipfhwc[ rhwrfhewhfodhf jwoie rhfewoif ov "} */}
//               <br />
//               <strong>Website:</strong> {company?.domain || "-"}
//               <br />
//               <strong>Contact:</strong> {company?.contact || "-"}
//               <br />
//               <strong>Email:</strong> {company?.email || "-"}
//             </p>
//           </div>

//           <div className="branch-loan-card-qr-box">
//             <img
//               // src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${loanId}`}
//               src={company?.qrCodeUrl}
//               alt="QR Code"
//               className="branch-loan-card-qr"
//             />
//           </div>

//         </header>

//         {/* Title */}
//         <div className="branch-loan-card-title-section">
//           <div className="branch-loan-card-barcode-top">
//             <Barcode
//               value={loanId}
//               height={40}
//               displayValue={true}
//               fontSize={14}
//               margin={0}
//             />
//           </div>
//           <h3 className="branch-loan-card-title">Loan EMI Card</h3>
//         </div>

//         {/* Loan & Customer Details */}
//         <div className="branch-loan-card-loan-details">
//           <table className="branch-loan-card-detail-table">
//             <tbody>
//               <tr>
//                 <td>
//                   <strong>Customer Name:</strong> {loan.userName || "-"}
//                 </td>
//                 <td>
//                   <strong>Loan ID:</strong>{" "}
//                   {loan.loanAccountNumber || loan.loanNumber}
//                 </td>
//                 <td rowSpan="4" className="branch-loan-card-photo-cell">
//                   <img
//                     src={
//                       photoUrl ||
//                       "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                     }
//                     alt="Customer"
//                     className="branch-loan-card-photo"
//                   />
//                 </td>
//               </tr>
//               {/* <tr>
//                 <td>
//                   <strong>Contact No:</strong> {loan.contactNo || "-"}
//                 </td>
//                 <td>
//                   <strong>Guardian Name:</strong> {loan.guardianName || "-"}
//                 </td>
//               </tr> */}
//               <tr>
//                 <td>
//                   <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
//                 </td>
//                 <td>
//                   <strong>Plan Name:</strong>{" "}
//                   {loan.loanService || loan.loanService || "-"}
//                 </td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Number of EMI:</strong> {emis.length}
//                 </td>
//                 <td>
//                   <strong>EMI Amount:</strong>{" "}
//                   {formatAmount(emiAmountFromSchedule)}
//                 </td>
//               </tr>
//                <tr>
//                 <td colSpan={2}>
//                   <strong>Address: </strong>{customerDetails?.address}
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           <div className="branch-loan-card-branch-info">
//             <p>
//               <strong>Branch : </strong> {profile?.branchName || "-"}
//             </p>
//             <p>
//               <strong>Date : </strong> {new Date().toLocaleDateString("en-GB")}
//             </p>
//           </div>
//         </div>

//         {/* EMI Table */}
//         <section className="branch-loan-card-table-section">
//           <h4>EMI Schedule Terms</h4>
//           <table className="branch-loan-card-table">
//             <thead>
//               <tr>
//                 <th>Sr. No</th>
//                 <th>Loan EMI Date</th>
//                {loan?.loanType==="personal" && (
//                 <>
//                 <th>Interest</th>
//                 <th>Principal</th>
//                 </>
//                )}
//                 <th>EMI</th>
//                 <th>Receiving Date</th>
//                 <th>Received Amt</th>
//                 <th>Staff Sign</th>
//                 <th>Member Sign</th>
//               </tr>
//             </thead>
//             <tbody>
//               {emis.map((emi, idx) => (
//                 <tr key={idx}>
//                   <td>{idx + 1}</td>
//                   <td>{formatDate(emi.dueDate)}</td>
//                   {loan?.loanType==="personal" && (
//                 <>
//                  <td>{formatAmount(emi.interestComponent)}</td>
//                   <td>{formatAmount(emi.principalComponent)}</td>
//                 </>
//                )}
//                   <td>{formatAmount(emi.emiAmount)}</td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                   <td></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </section>

//         {/* Footer */}
//         <footer className="branch-loan-card-footer">
//           <div>
//             Member Signature
//             <br />
//             (सदस्य के हस्ताक्षर)
//           </div>
//           <div>
//             Spouse Signature
//             <br />
//             (जीवनसाथी के हस्ताक्षर)
//           </div>

//           <div>
//             Branch Seal With Signature
//             <br />
//             (शाखा मोहर के साथ हस्ताक्षर)
//           </div>
//         </footer>
//       </div>

//       {/* PDF Button */}
//       <div style={{ textAlign: "center" }}>
//         <button onClick={generatePDF} className="branch-loan-card-download-btn">
//           📄 Download PDF
//         </button>
//       </div>
//     </div>
//   );
// };
// export default LoanCard;



// src/Loan/LoanCard.jsx
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  fetchLoanEmis,
  clearLoanEmis,
} from "../redux/slices/loan/loanEmiSlice";
import { fetchAllLoans } from "../redux/slices/loan/loanReportSlice";
import jsPDF from "jspdf";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import "../assets/Loan/LoanCard.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";

// Utils
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return isNaN(date) ? dateStr : date.toLocaleDateString("en-GB");
};

const formatAmount = (amount) =>
  !amount ? "Rs 0" : `Rs ${Number(amount).toLocaleString("en-IN")}`;

const LoanCard = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const cardRef = useRef();
  const location = useLocation();

  const {
    emis,
    loading: emiLoading,
    error: emiError,
  } = useSelector((state) => state.loanEmi);
  const {
    loans,
    loading: loanLoading,
    error: loanError,
  } = useSelector((state) => state.loanReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [branchSealUrl, setBranchSealUrl] = useState(null);
  const [branchSignUrl, setBranchSignUrl] = useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  // ✅ Fetch Profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ✅ Fetch Loan + Company
  useEffect(() => {
    if (loanId) {
      dispatch(fetchLoanEmis(loanId));
      if (loans.length === 0) dispatch(fetchAllLoans());
    }

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          if (data.qrCodeImage) {
            data.qrCodeUrl = `https://payyug.in/${data.qrCodeImage.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company:", err);
      }
    };
    if (profile?.superAdminId) fetchCompany();

    return () => dispatch(clearLoanEmis());
  }, [dispatch, loanId, loans.length, profile?.superAdminId]);

  const loan = loans.find((l) => String(l.id) === String(loanId)) || null;
  const emiAmountFromSchedule = emis?.[0]?.emiAmount || "NA";

  // ✅ Fetch Customer Details & Photo
  useEffect(() => {
    if (!loan?.customerId) return;

    const branchId = Number(localStorage.getItem("userId")) || 0;

    const fetchCustomerDetails = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/customers-get-userId?userId=${loan.customerId}&branchId=${branchId}`,
        );
        const data = await res.json();
        setCustomerDetails(data.data);
      } catch (err) {
        console.error("Customer fetch error:", err);
      }
    };

    const fetchCustomerPhoto = async () => {
      try {
        if (profile?.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/list-kyc?userId=${loan.customerId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`,
          );
          const data = await res.json();
          if (res.ok && data.documents?.length > 0) {
            const photoDoc = data.documents.find(
              (doc) => doc.docName?.toLowerCase() === "photo",
            );
            if (photoDoc?.docImage) {
              setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
            }
          }
        }
      } catch (err) {
        console.error("Failed to fetch customer photo:", err);
      }
    };

    fetchCustomerDetails();
    fetchCustomerPhoto();
  }, [loan?.customerId, profile?.superAdminId, profile?.id, createdById]);

  useEffect(() => {
    const fetchSealSign = async () => {
      if (!profile?.superAdminId) return;

      try {
        const res = await axios.get(
          `https://payyug.in/api/list/stamp?superAdminId=${profile?.superAdminId}&category=Loan Card`,
        );

        const dataArray = res?.data?.data?.[0] || [];

        if (dataArray && dataArray.file) {
          const cleanSealPath = dataArray.file.replace(/^images\//, "");
          setBranchSealUrl(`https://payyug.in/${cleanSealPath}`);
        } else {
          setBranchSealUrl(null);
        }

        if (dataArray && dataArray.type) {
          const cleanSignPath = dataArray.type.replace(/^images\//, "");
          setBranchSignUrl(`https://payyug.in/${cleanSignPath}`);
        } else {
          setBranchSignUrl(null);
        }
      } catch (error) {
        console.error("API Fetch Error:", error);
      }
    };

    fetchSealSign();
  }, [profile?.superAdminId]);

  const generatePDF = async () => {
    const input = cardRef.current;
    if (!input) return;

    const downloadBtns = document.querySelectorAll(".branch-loan-card-download-btn");
    downloadBtns.forEach((btn) => (btn.style.display = "none"));

    const pdf = new jsPDF("p", "mm", "a4", true);
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 10;
    const contentWidth = pageWidth - margin * 2;
    const contentHeight = pageHeight - margin * 2;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollY: -window.scrollY,
    });

    const imgWidth = canvas.width;
    const pixelPageHeight = (imgWidth * contentHeight) / contentWidth;

    let heightLeft = canvas.height;
    let sY = 0;

    const targetElements = input.querySelectorAll(".print-row");
    let breakPoints = [];

    targetElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const inputRect = input.getBoundingClientRect();
      const relativeTop = rect.top - inputRect.top;

      const canvasTop = relativeTop * 2;
      breakPoints.push(canvasTop);
    });

    while (heightLeft > 0) {
      let sHeight = pixelPageHeight;

      if (heightLeft > pixelPageHeight) {
        const expectedPageEnd = sY + pixelPageHeight;
        let bestBreakPoint = sY + pixelPageHeight;

        for (let i = 0; i < breakPoints.length; i++) {
          if (breakPoints[i] > sY && breakPoints[i] < expectedPageEnd) {
            bestBreakPoint = breakPoints[i];
          }
        }

        if (bestBreakPoint !== sY + pixelPageHeight) {
          sHeight = bestBreakPoint - sY;
        }
      } else {
        sHeight = heightLeft;
      }

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = imgWidth;
      pageCanvas.height = pixelPageHeight;

      const ctx = pageCanvas.getContext("2d");

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

      ctx.drawImage(canvas, 0, sY, imgWidth, sHeight, 0, 0, imgWidth, sHeight);

      const pageImgData = pageCanvas.toDataURL("image/jpeg", 1.0);
      const displayHeight_mm = contentHeight;

      if (sY > 0) pdf.addPage();

      pdf.addImage(
        pageImgData,
        "JPEG",
        margin,
        margin,
        contentWidth,
        displayHeight_mm,
      );

      sY += sHeight;
      heightLeft -= sHeight;
    }

    downloadBtns.forEach((btn) => (btn.style.display = "inline-block"));

    pdf.save(`${loan?.userName}_LoanCard.pdf`);
  };

const triggerPrintElement = (elementRef, title = "Print_Document") => {
    const input = elementRef.current;
    if (!input) return;

    // Purana iframe saaf karein
    const existingIframe = document.getElementById("print-iframe");
    if (existingIframe) {
      document.body.removeChild(existingIframe);
    }

    const iframe = document.createElement("iframe");
    iframe.id = "print-iframe";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    // Document ke active styles copy karein
    let extractedStyles = "";
    document.querySelectorAll("style, link[rel='stylesheet']").forEach((node) => {
      extractedStyles += node.outerHTML;
    });

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title}</title>
          ${extractedStyles}
          <style>
            @page {
              size: A4 portrait;
              margin: 8mm 10mm;
            }
            *, *::before, *::after {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              box-sizing: border-box !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
            body {
              background: #ffffff !important;
              color: #000000 !important;
              font-family: Arial, Helvetica, sans-serif !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            /* Structure Lock */
            .branch-loan-card-container {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 auto !important;
              padding: 0 !important;
              box-shadow: none !important;
              display: block !important;
            }
            .branch-loan-card-header {
              display: flex !important;
              flex-direction: row !important;
              justify-content: space-between !important;
              align-items: center !important;
              padding: 10px 14px !important;
              box-sizing: border-box !important;
            }
            .branch-loan-card-logo-box {
              width: 90px !important;
              height: 90px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              overflow: hidden !important;
              flex-shrink: 0 !important;
            }
            .branch-loan-card-logo {
              max-width: 100% !important;
              max-height: 100% !important;
              width: auto !important;
              height: auto !important;
              object-fit: contain !important;
              border-radius: 50% !important;
              display: block !important;
            }
            .branch-loan-card-qr-box {
              width: 80px !important;
              height: 80px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              flex-shrink: 0 !important;
            }
            .branch-loan-card-qr {
              max-width: 100% !important;
              max-height: 100% !important;
              object-fit: contain !important;
              display: block !important;
            }
            .branch-loan-card-details-box {
              text-align: center !important;
              flex: 1 !important;
            }
            .branch-loan-card-details-box h2 {
              font-size: 16px !important;
              font-weight: bold !important;
              margin: 0 0 4px 0 !important;
              color: #000 !important;
            }
            .branch-loan-card-details-box p {
              font-size: 10px !important;
              line-height: 1.3 !important;
              margin: 0 !important;
              color: #000 !important;
            }
            .branch-loan-card-title-section {
              display: flex !important;
              flex-direction: row !important;
              justify-content: space-between !important;
              align-items: center !important;
              padding: 4px 10px !important;
            }
            .branch-loan-card-title {
              font-size: 14px !important;
              font-weight: bold !important;
              text-decoration: underline !important;
              margin: 0 !important;
            }
            table {
              width: 100% !important;
            }
            th, td {
              padding: 4px 6px !important;
              font-size: 10px !important;
              color: #000 !important;
            }
            th {
              background-color: #f1f5f9 !important;
              font-weight: bold !important;
            }
            .branch-loan-card-branch-info {
              display: flex !important;
              justify-content: space-between !important;
              padding: 6px 10px !important;
              font-size: 11px !important;
              font-weight: bold !important;
            }
            .branch-loan-card-footer {
              display: flex !important;
              flex-direction: row !important;
              justify-content: space-between !important;
              padding: 15px 10px 10px !important;
              margin-top: 10px !important;
            }
            .box-size {
              flex: 1 !important;
              text-align: center !important;
              font-size: 10px !important;
              font-weight: 600 !important;
            }
            .border-line {
              margin-top: 15px !important;
            }
            img {
              max-width: 100% !important;
              height: auto !important;
            }
            button, .branch-loan-card-download-btn, [class*="download-btn"], [class*="print-btn"] {
              display: none !important;
            }
          </style>
        </head>
        <body>
          <div class="branch-loan-card-container">
            ${input.innerHTML}
          </div>
        </body>
      </html>
    `);
    doc.close();

    const checkAndPrint = () => {
      const iframeImages = doc.querySelectorAll("img");
      const promises = Array.from(iframeImages).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      });

      Promise.all(promises).then(() => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 200);
      });
    };

    if (doc.readyState === "complete") {
      checkAndPrint();
    } else {
      iframe.contentWindow.onload = checkAndPrint;
    }
  };

  const handlePrint = () => {
    triggerPrintElement(cardRef, `${loan?.userName || "Customer"}_LoanCard`);
  };

  if (loanLoading || emiLoading)
    return <div className="branch-loan-card-container">Loading...</div>;
  if (loanError || emiError)
    return (
      <div className="branch-loan-card-container">{loanError || emiError}</div>
    );
  if (!loan)
    return (
      <div className="branch-loan-card-container">
        No loan found for Loan ID {loanId}
      </div>
    );

  return (
    <div>
      <div className="branch-loan-card-container" ref={cardRef}>
        {/* Header */}
        <header className="branch-loan-card-header">
          <div className="branch-loan-card-logo-box">
            {company?.logoUrl && (
              <img
                src={company.logoUrl}
                alt="Logo"
                className="branch-loan-card-logo"
              />
            )}
          </div>

          <div className="branch-loan-card-details-box">
            <h2>{company?.name || "Company Name"}</h2>
            <p>
              <strong>CIN:</strong> {company?.cin || "-"}
              <br />
              {company?.address || "-"}
              <br />
              <strong>Website:</strong> {company?.domain || "-"}
              <br />
              <strong>Contact:</strong> {company?.contact || "-"}
              <br />
              <strong>Email:</strong> {company?.email || "-"}
            </p>
          </div>

          <div className="branch-loan-card-qr-box">
            <img
              src={company?.qrCodeUrl}
              alt="QR Code"
              className="branch-loan-card-qr"
            />
          </div>
        </header>

        {/* Title */}
        <div className="branch-loan-card-title-section">
          <div className="branch-loan-card-barcode-top">
            <Barcode
              value={loanId}
              height={40}
              displayValue={true}
              fontSize={14}
              margin={0}
            />
          </div>
          <h3 className="branch-loan-card-title">Loan EMI Card</h3>
        </div>

        {/* Loan & Customer Details */}
        <div className="branch-loan-card-loan-details">
          <table className="branch-loan-card-detail-table">
            <tbody>
              <tr>
                <td>
                  <strong>Customer Name:</strong> {loan.userName || "-"}
                </td>
                <td>
                  <strong>Loan ID:</strong>{" "}
                  {loan.loanAccountNumber || loan.loanNumber}
                </td>
                <td rowSpan="3" className="branch-loan-card-photo-cell">
                  <img
                    src={
                      photoUrl ||
                      "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                    }
                    alt="Customer"
                    className="branch-loan-card-photo"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
                </td>
                <td>
                  <strong>Loan Type:</strong> {loan.loanType || "-"}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Plan Name:</strong> {loan.loanService || "-"}
                </td>
                <td>
                  <strong>Number of EMI:</strong> {emis.length}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>EMI Amount:</strong>{" "}
                  {formatAmount(emiAmountFromSchedule)}
                </td>
                <td colSpan={2}>
                  <strong>Address: </strong>
                  {customerDetails?.address || "-"}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="branch-loan-card-branch-info">
            <p>
              <strong>Branch : </strong> {profile?.branchName || "-"}
            </p>
            <p>
              <strong>Disbursal Date : </strong>{" "}
              {loan?.disbursalDate
                ? new Date(loan?.disbursalDate).toLocaleDateString("en-GB")
                : new Date().toLocaleDateString("en-GB")}
            </p>
          </div>
        </div>

        {/* EMI Table */}
        <section className="branch-loan-card-table-section">
          <h4>EMI Schedule Terms</h4>
          <table className="branch-loan-card-table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Loan EMI Date</th>
                {loan?.loanType?.toLowerCase() === "personal" && (
                  <>
                    <th>Interest</th>
                    <th>Principal</th>
                  </>
                )}
                <th>EMI</th>
                <th>Receiving Date</th>
                <th>Received Amt</th>
                <th>Staff Sign</th>
                <th>Member Sign</th>
              </tr>
            </thead>
            <tbody>
              {emis.map((emi, idx) => (
                <tr key={idx} className="print-row">
                  <td>{idx + 1}</td>
                  <td>{formatDate(emi.dueDate)}</td>
                  {loan?.loanType?.toLowerCase() === "personal" && (
                    <>
                      <td>{formatAmount(emi.interestComponent)}</td>
                      <td>{formatAmount(emi.principalComponent)}</td>
                    </>
                  )}
                  <td>{formatAmount(emi.emiAmount)}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Footer Block Wrapper */}
        <footer className="branch-loan-card-footer print-row">
          <div className="box-size">
            Member Signature
            <br />
            (सदस्य के हस्ताक्षर)
            <div className="border-line"></div>
          </div>
          <div className="box-size">
            Guarantor Signature
            <br />
            (गारंटीकर्ता के हस्ताक्षर)
            <div className="border-line"></div>
          </div>

          <div className="box-size">
            President/Secretary Signature
            <br />
            (अध्यक्ष/सचिव के हस्ताक्षर)
            <div className="border-line"></div>
          </div>
          <div className="footer-seal-sign box-size">
            Branch Seal With Signature
            <br />
            (शाखा मोहर के साथ हस्ताक्षर)
            <div className="border-line"></div>
            {branchSealUrl && (
              <div className="footer-seal">
                <img src={branchSealUrl} alt="Seal" />
              </div>
            )}
            {branchSignUrl && (
              <div className="footer-sign">
                <img src={branchSignUrl} alt="Signature" />
              </div>
            )}
          </div>
        </footer>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          marginTop: "16px",
        }}
      >
        <button
          onClick={handlePrint}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          🖨️ Print Card
        </button>

        <button
          onClick={generatePDF}
          className="branch-loan-card-download-btn"
          style={{ cursor: "pointer" }}
        >
          📄 Download PDF
        </button>
      </div>
    </div>
  );
};

export default LoanCard;